'use strict';
require('./../DashboardModalBrewBody/DashboardModalBrewBody.scss');

const React = require('react'),
    _ = require('lodash'),
    {t} = require('services/i18nextWrapper'),
    ContentUtils = require('utils/ContentUtils'),
    DateUtils = require('utils/DateUtils'),
    { PropTypes } = require('react'),
    SessionStore = require('stores/SessionStore'),
    BeerStyleStore = require('stores/BeerStyleStore'),
    {TextField} = require('material-ui'),
    DropDown = require('components/Commons/DropDown/DropDown'),
    AppConstants = require('constants/AppConstants'),
    { DatePicker, SelectField } = require('material-ui');

const DashboardModalSingleBody = React.createClass({displayName: "DashboardModalSingleBody",
    propTypes: {
        sectionName: PropTypes.string,
        initFromDate: PropTypes.string,
        initToDate: PropTypes.string,
        onChangeFromDate: PropTypes.func,
        isBeerStyleAlreadyDefined: PropTypes.bool,
        onChangeVolume: PropTypes.func,
        onChangeComment: PropTypes.func,
        onChangeToDate: PropTypes.func,
        onChangeCloseOrder: PropTypes.func,
        onChangeBeerStyle: PropTypes.func,
        onChangeTank: PropTypes.func,
        parentState: PropTypes.object,
        tankSelected: PropTypes.object,
        refsSubscriber: PropTypes.object
    },

    render() {
        const {
            onChangeComment,
            refsSubscriber,
            parentState,
            onChangeTank,
            onChangeFromDate,
            onChangeToDate,
            onChangeBeerStyle,
            initFromDate,
            initToDate,
            onChangeVolume,
            sectionName,
            tankTypeClicked
        } = this.props;

        // only disabled if beerStyle is not defined or is a Guest user
        let isDisabledComponent = isDisableComponent(parentState);

        if (!isDisabledComponent) {
            // only disabled if beerStyle is not defined or is a Guest user
            isDisabledComponent = isDisableComponent(parentState, tankTypeClicked);
        }

        const isBrewingSection = sectionName === AppConstants.BREWING_SECTION_NAME;
        const isNewModal = parentState.isNewModal;
        const haveErrorText = _.get(parentState, 'styleBeerMessageError.length') > 0;
        return (
          React.createElement("div", null, 
            React.createElement("div", {className: "visible-xs row"}, 
              React.createElement("div", {className: "col-xs-12 col-sm-6"}, 
                React.createElement(DropDown, {
                  floatingLabelText: t('dashboard_modal_general_beer_style'), 
                  onChange: onChangeBeerStyle, 
                  ref: input => refsSubscriber.beerStyle = input, 
                  wrapperMenuItem: _getWrapperColor, 
                  items: isNewModal ? ContentUtils.filterEnable(BeerStyleStore.getBeerStyles()) : BeerStyleStore.getBeerStyles(), 
                  style: {minWidth: '250px', marginBottom: haveErrorText ? '25px' : '7px'}, 
                  errorStyle: {color: isNewModal ? 'blue !important' : '#B3B3B3'}, 
                  errorText: parentState.styleBeerMessageError, 
                  selectedIndex: parentState.styleBeerSelectedIndex, 
                  disabled: !isNewModal ? true : isDisabledComponent, 
                  readerAttribute: "name", 
                  name: t('dashboard_modal_general_beer_style')
                }
                ), 
                React.createElement(SelectField, {
                  floatingLabelText: 
                    sectionName + (isBrewingSection ? ` ${t('turn')}` : ` ${t('tank')}`), 
                  
                  onChange: onChangeTank, 
                  menuItems: parentState.tankMenuItems, 
                  errorText: parentState.tankMessageError, 
                  value: parentState.singleTankIndex, 
                  disabled: isDisabledComponent}
                ), 
                React.createElement(TextField, {
                  ref: input => (refsSubscriber.orderVolume = input), 
                  floatingLabelText: t('dashboard_modal_general_volume'), 
                  onBlur: onChangeVolume, 
                  errorText: parentState.volumenTankMessageError, 
                  defaultValue: _.get(parentState, 'orderVolume'), 
                  disabled: isDisabledComponent || _.get(parentState, 'isSomeProductAlreadyConfirmed')}
                )
              ), 
              React.createElement("div", {className: "col-xs-12 col-sm-6"}, 
                      React.createElement(DatePicker, {
                        floatingLabelText: t('dashboard_modal_general_from_date'), 
                        hintText: t('dashboard_modal_general_from_date'), 
                        formatDate: DateUtils.toDisplayDateText, 
                        value: parentState.fromDate || initFromDate, 
                        onChange: isDisabledComponent ? () => {
                        } : onChangeFromDate, 
                        errorText: parentState.fromDateMessageError, 
                        disabled: isDisabledComponent, 
                        maxDate: parentState.toDate}
                      ), 
                      React.createElement(DatePicker, {
                        floatingLabelText: t('dashboard_modal_general_to_date'), 
                        hintText: t('dashboard_modal_general_to_date'), 
                        formatDate: DateUtils.toDisplayDateText, 
                        value: parentState.toDate || initToDate, 
                        onChange: isDisabledComponent ? () => {
                        } : onChangeToDate, 
                        errorText: parentState.toDateMessageError, 
                        disabled: isDisabledComponent, 
                        minDate: parentState.fromDate}
                      )
                      
                  ), 
              React.createElement("div", {className: "col-xs-12"}, 
                      React.createElement(TextField, {
                        onBlur: onChangeComment, 
                        floatingLabelText: t('dashboard_modal_general_add_comment'), 
                        multiLine: true, 
                        defaultValue: _.get(parentState, 'order.comment', ''), 
                        style: {width: '100%'}, 
                        disabled: isDisabledComponent}
                      )
                  ), 
              React.createElement("div", {className: "clearfix"})
            ), 
            React.createElement("div", {className: "hidden-xs row"}, 
              React.createElement("div", {className: "col-xs-12 col-sm-6"}, 
                      React.createElement(DatePicker, {
                        floatingLabelText: t('dashboard_modal_general_from_date'), 
                        hintText: t('dashboard_modal_general_from_date'), 
                        formatDate: DateUtils.toDisplayDateText, 
                        value: parentState.fromDate || initFromDate, 
                        onChange: isDisabledComponent ? () => {
                        } : onChangeFromDate, 
                        errorText: parentState.fromDateMessageError, 
                        disabled: isDisabledComponent, 
                        maxDate: parentState.toDate}
                      ), 
                      React.createElement(DatePicker, {
                        floatingLabelText: t('dashboard_modal_general_to_date'), 
                        hintText: t('dashboard_modal_general_to_date'), 
                        formatDate: DateUtils.toDisplayDateText, 
                        value: parentState.toDate || initToDate, 
                        onChange: isDisabledComponent ? () => {
                        } : onChangeToDate, 
                        errorText: parentState.toDateMessageError, 
                        disabled: isDisabledComponent, 
                        minDate: parentState.fromDate}
                      )
                      
                  ), 
              React.createElement("div", {className: "col-xs-12 col-sm-6"}, 
                      React.createElement(DropDown, {
                        floatingLabelText: t('dashboard_modal_general_beer_style'), 
                        onChange: onChangeBeerStyle, 
                        ref: input => refsSubscriber.beerStyle = input, 
                        wrapperMenuItem: _getWrapperColor, 
                        items: isNewModal ? ContentUtils.filterEnable(BeerStyleStore.getBeerStyles()) : BeerStyleStore.getBeerStyles(), 
                        style: {minWidth: '250px', marginBottom: haveErrorText ? '25px' : '7px'}, 
                        errorStyle: {color: isNewModal ? 'blue !important' : '#B3B3B3'}, 
                        errorText: parentState.styleBeerMessageError, 
                        selectedIndex: parentState.styleBeerSelectedIndex, 
                        disabled: !isNewModal ? true : isDisabledComponent, 
                        readerAttribute: "name", 
                        name: t('dashboard_modal_general_beer_style')
                      }
                      ), 
                      React.createElement(SelectField, {
                        floatingLabelText: 
                            sectionName + (isBrewingSection ? ` ${t('turn')}` : ` ${t('tank')}`), 
                        
                        onChange: onChangeTank, 
                        menuItems: parentState.tankMenuItems, 
                        errorText: parentState.tankMessageError, 
                        value: parentState.singleTankIndex, 
                        disabled: isDisabledComponent}
                      ), 
                      React.createElement(TextField, {
                        ref: input => (refsSubscriber.orderVolume = input), 
                        floatingLabelText: t('dashboard_modal_general_volume'), 
                        onBlur: onChangeVolume, 
                        errorText: parentState.volumenTankMessageError, 
                        defaultValue: _.get(parentState, 'orderVolume'), 
                        disabled: isDisabledComponent || _.get(parentState, 'isSomeProductAlreadyConfirmed')}
                      )
                  ), 
              React.createElement("div", {className: "col-xs-12"}, 
                      React.createElement(TextField, {
                        onBlur: onChangeComment, 
                        floatingLabelText: t('dashboard_modal_general_add_comment'), 
                        multiLine: true, 
                        defaultValue: _.get(parentState, 'order.comment', ''), 
                        style: {width: '100%'}, 
                        disabled: isDisabledComponent}
                      )
                  ), 
              React.createElement("div", {className: "clearfix"})
            )
          )
        );
    }
});

function isDisableComponent(parentState, tankTypeClicked) {
    return SessionStore.isAdminUser() ? false :
        (!SessionStore.isAdminUser() || tankTypeClicked) ? false : !parentState.isBeerStyleAlreadyDefined;
}

function _getWrapperColor(item) {
    const isMenuItemUsed = item.payload !== undefined;
    let beerStyle;

    if (isMenuItemUsed) {
        beerStyle = item.itemModel;
    } else {
        beerStyle = item;
    }

    return (
        React.createElement("div", null, 
                React.createElement("span", {
                    className: "text-center", 
                    style: {
                        height: '20px',
                        borderRadius: '22px',
                        boxShadow: (beerStyle ? '1px 2px 4px 0px gray' : '0 0 0 0 #fff'),
                        backgroundColor: _.get(beerStyle, 'color'),
                        border: 'solid 0px black',
                        padding: '8px 16px',
                        left: '0',
                        position: 'relative',
                        opacity: '.6'
                    }}
                ), 
            React.createElement("span", {style: {paddingLeft: '10px'}}, _.get(beerStyle, 'name') || _.get(item, 'text'))
        )
    );
}

module.exports = DashboardModalSingleBody;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalSingleBody/DashboardModalSingleBody.jsx
 **/